import { useMyBalance } from "api/Client/balance";
import { Spinner } from "components";
import useCurrentLocation from "Hooks/useCurrentLocation";
import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import PropTypes from "prop-types";
import { BiSupport } from "react-icons/bi";
import {
  BsBuildingAdd,
  BsBuildingDash,
  BsFillSendArrowUpFill,
} from "react-icons/bs";
import { FcBusinessman } from "react-icons/fc";
import { HiMiniNewspaper } from "react-icons/hi2";
import { MdHomeWork } from "react-icons/md";
import { PiHandDepositFill, PiHandWithdrawFill } from "react-icons/pi";
import { useSelector } from "react-redux";

import { AiFillAndroid } from "react-icons/ai";
import { MdNotificationsActive } from "react-icons/md";

import { IoExit } from "react-icons/io5";
import { PiPasswordFill } from "react-icons/pi";

import { IoSendSharp } from "react-icons/io5";
const links = [
  {
    url: "/control-panel",
    icon: <MdHomeWork className="text-white" />,
    title: "الرئيسية",
  },
  {
    url: "/control-panel/bank-notice",
    icon: <PiHandDepositFill className="text-white" />,
    title: "إيداع",
  },
  {
    url: "/control-panel/categories",
    icon: <PiHandWithdrawFill className="text-white" />,
    title: "سحب",
  },
  {
    url: "/control-panel/my-orders",
    icon: <BsBuildingDash className="text-white" />,
    title: "سجل السحب",
  },

  {
    url: "/control-panel/my-payments",
    icon: <BsBuildingAdd className="text-white" />,
    title: "سجل الإيداع",
  },

  {
    url: "/control-panel/financial-statement",
    icon: <HiMiniNewspaper className="text-white" />,
    title: "البيان المالي",
  },
];
const links2 = [
  {
    title: "إشعارات التطبيق",
    url: "/control-panel/notifications",
    icon: <MdNotificationsActive className="text-white" />,
  },
  {
    url: "/control-panel/contact-us",
    icon: <BiSupport className="text-white" />,
    title: "الدعم الفني",
  },
  {
    title: "تغير كلمة المرور",
    url: "/control-panel/change-password",
    icon: <PiPasswordFill className="text-white" />,
  },
  { title: "خروج", url: "/logout", icon: <IoExit className="text-white" /> },
];

const SidebarLink = ({ link, navigate, isActive }) => (
  <li>
    <div
      onClick={() => navigate(link.url)}
      className={`px-2 py-2 rounded-md text-nowrap cursor-pointer hover:bg-white/15 duration-700 flex gap-2 items-center group ${
        isActive ? "bg-white/15" : ""
      }`}
    >
      <p className="text-2xl duration-700 group-hover:scale-125">{link.icon}</p>
      {link.title}
    </div>
  </li>
);

SidebarLink.propTypes = {
  link: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

const SidebarSection = ({ title, links, navigate, currentLocation }) => (
  <ul className="flex-col px-4 flex text-white gap-1 mt-4 py-1">
    {title && <h2 className="text-yellow-500 font-bold">{title}</h2>}
    {links.map((link, index) => (
      <SidebarLink
        key={index}
        link={link}
        navigate={navigate}
        isActive={currentLocation === link.url}
      />
    ))}
  </ul>
);

SidebarSection.propTypes = {
  title: PropTypes.string,
  links: PropTypes.array.isRequired,
  navigate: PropTypes.func.isRequired,
  currentLocation: PropTypes.string.isRequired,
};

export default function Sidebar({ isOpen, toggle }) {
  const currentLocation = useCurrentLocation();
  const navigate = useViewTransitionNavigate();
  const { name, roles } = useSelector((state) => state.auth);
  const { isBroker } = useSelector((state) => state.balance);

  const {
    data: myBalance,
    isFetching: myBalanceIsLoading,
    isSuccess: myBalanceIsSuccess,
  } = useMyBalance();

  return (
    <>
      <div
        className={`fixed overflow-auto lg:hidden z-50 !w-64 flex flex-col top-16 bottom-0 bg-mainLight py-2 ${
          isOpen ? "right-0" : "-right-64"
        } transition-all duration-300`}
      >
        {/* User Info Section */}
        <div className="flex flex-col items-center pb-4 border-b-2 border-white">
          <FcBusinessman
            className="text-8xl cursor-pointer hover:opacity-80"
            onClick={() => {
              navigate("/control-panel/my-profile");
            }}
          />
          <div className="flex flex-col text-center text-white">
            <h1 className="text-lg font-bold">{name}</h1>
            {/* <h1 className="text-sm mt-1 text-gray-200">{roles[0]?.name}</h1> */}
            <h1 className="flex items-center gap-2 mt-3 py-0.5 h-9 px-2 shadow-md ">
              <span className="text-lg">{"الرصيد: "}</span>{" "}
              <span dir="ltr" className="text-white text-2xl">
                {myBalanceIsLoading && (
                  <span className="bg-white w-7 h-7 grid place-items-center mx-auto rounded-2xl">
                    <Spinner xs />
                  </span>
                )}
                {myBalanceIsSuccess && !myBalanceIsLoading && (
                  <span>
                    {Number(myBalance?.data.balance).toLocaleString()}{" "}
                    <span className="text-sm">{myBalance?.data.currency}</span>
                  </span>
                )}
              </span>
            </h1>
          </div>
        </div>

        {/* Links Sections */}
        <div className="flex flex-col justify-between h-full">
          {" "}
          <SidebarSection
            links={[
              ...links,
              ...(!!isBroker
                ? [
                    {
                      title: "ارسال",
                      url: "/control-panel/transfer",
                      icon: <BsFillSendArrowUpFill />,
                    },
                  ]
                : []),
              ...links2,
            ]}
            navigate={navigate}
            currentLocation={currentLocation}
          />
          {/* <SidebarSection
            links={settingsLinks}
            navigate={navigate}
            currentLocation={currentLocation}
          /> */}
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed backdrop-blur-[3px] top-16 bottom-0 right-0 left-0 z-40 lg:hidden"
          onClick={() => toggle(false)}
        ></div>
      )}
    </>
  );
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
